/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungKopfdatenAktualisierenRequest { 
    titel?: string;
    beginn_utc?: Date;
    einlass_utc?: Date;
    veranstaltungsleiter_rolle_id?: string;
    beobachter_rolle_id?: string;
    kopfdaten?: { [key: string]: string; };
    veranstaltung_id: string;
}

